import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { Box } from '@mui/material';
import CommonCard from '../item/common_card';
import { FONT_COLOR } from '../const/general';
import { TypographyTitleLarge } from '../style/typography';
import { BoxCenterStart } from '../style/box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

export default function ThreeDayShelter(props) {
  const [shelterList, setShelterList] = useState([]);
  const [shelterCount, setShelterCount] = useState(0);

  const tableHeight = React.useMemo(() => {
    if (!props.height) return '240px';
    // props.height が '200px' や '100%'、あるいは数値の場合に対応
    if (typeof props.height === 'number') {
      return `calc(${props.height}px)`;
    }
    return `calc(${props.height})`;
  }, [props.height]);

  // 情報を格納
  const setInfo = (shelter_data) => {
    if (shelter_data === null || shelter_data === Number.NEGATIVE_INFINITY) {
      setShelterList([]);
      setShelterCount(0);
      return;
    }

    // txt_area_name のみ抽出
    const list = shelter_data.map(s => (s && typeof s.txt_area_name === 'string') ? s.txt_area_name : '');
    setShelterList(list);
    setShelterCount(shelter_data.length);
  }

  // 定期監視用
  useEffect(() => {
    setInfo(props.shelterVal)
  }, [props.shelterVal]);

  // 定期監視用
  useEffect(() => {
    setInfo(props.shelterVal)
  }, []);

  return (
    <Grid container columns={12} spacing={0} >
      {props.title !== undefined &&
        <Grid size={{ xs: 12, md: 12 }}>
          <CommonCard
            child={
              <BoxCenterStart sx={{ flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, width: '100%' }}>
                {/* 左：件数表示 */}
                <BoxCenterStart sx={{ flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', width: '30%', height: '100%' }}>
                  <Box sx={{ mt: '100%' }}>
                    <TypographyTitleLarge sx={{ color: FONT_COLOR, fontSize: '3rem' }}>{`${shelterCount}件`}</TypographyTitleLarge>
                  </Box>
                </BoxCenterStart>
                {/* 右：避難所名テーブル表示 */}
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '70%', alignItems: 'flex-start' }}>
                  {/* テーブル（スクロール領域） */}
                  <TableContainer
                    component="div"
                    sx={{
                      maxHeight: tableHeight,
                      overflow: 'auto',
                      backgroundColor: 'transparent',
                      width: '100%'
                    }}
                  >
                    <Table stickyHeader={false} size="small" aria-label="shelter-table">
                      <TableBody>
                        {(!Array.isArray(shelterList) || shelterList.length === 0) ? (
                          <TableRow sx={{ borderTop: '1px solid rgba(255,255,255,0.2)', borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                            <TableCell sx={{ py: 2, textAlign: 'center', color: '#fff', backgroundColor: 'transparent', fontSize: '12px', borderBottom: 'none' }}>
                              データなし
                            </TableCell>
                          </TableRow>
                        ) : (
                          shelterList.map((name, idx) => (
                            <TableRow key={`${name}-${idx}`} sx={{ backgroundColor: 'transparent', borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                              <TableCell sx={{ color: '#fff', backgroundColor: 'transparent', px: 0, py: 0.5, fontSize: '12px', borderBottom: 'none', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {typeof name === 'string' ? (name.length > 9 ? `${name.slice(0, 9)}…` : name) : (name || '—')}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </BoxCenterStart>
            }
            title={props.title}
            xsHeight={props.xsHeight}
            height={props.height}
          />
        </Grid>
      }
    </Grid>
  );
}